import api from '../api'

export const screenGroupResource = {
  all () {
    return api().get('/GetScreenGroups')
  },

  create (payload) {
    return api().post('/CreateScreenGroup', payload)
  },

  addSchedule (screenGroupId, scheduleId) {
    return api().post('/AddScheduleToScreenGroup', { screenGroupId: screenGroupId, scheduleId: scheduleId })
  },

  addScreen (screenGroupId, deviceId) {
    return api().post('/AddScreensToScreenGroup', { screenGroupId: screenGroupId, deviceId: deviceId })
  }
}
